export default "__VITE_ASSET__U$rq7j5i__"